import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPromoInside = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Promo Enclosed",
		transform: "translate(-66.5 -529)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "translate(-35 401)",
			children: /* @__PURE__ */ _jsxs("g", {
				"data-name": "Ellipse 3",
				transform: "translate(103.5 130)",
				fill: "#ffb100",
				stroke: "#2b3236",
				strokeWidth: 2,
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 7,
					cy: 7,
					r: 7,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("circle", {
					cx: 7,
					cy: 7,
					r: 8,
					fill: "none"
				})]
			})
		}), /* @__PURE__ */ _jsx("path", {
			"data-name": "Path 5589",
			d: "M8.215,4.27l.967,2.086h1.882a.462.462,0,0,1,.325.806L9.758,8.77l.905,2.08a.493.493,0,0,1-.7.617L7.773,10.235l-2.19,1.232a.493.493,0,0,1-.7-.617l.905-2.079L4.156,7.163a.461.461,0,0,1,.321-.807H6.359L7.326,4.27a.5.5,0,0,1,.889,0Z",
			transform: "translate(67.729 530.233)",
			fill: "none",
			stroke: "#2b3236",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})]
	})
});
export { SvgIconPromoInside as ReactComponent };
